import { StateContext } from "@ngxs/store";
import { AppDataStateModel } from "@app/shared/models/app-data.model";
import { CommonSearchCriteria } from "@app/shared/models/common-data.model";
import { NgxsActionName } from "@app/shared/constants";
import { AwardStateProcessor } from "./processor/award-state-processor";
import { DriverDataStateProcessor } from "./processor/driver-data-state-processor";
import { OrgUnitStateProcessor } from "./processor/org-unit-state-processor";
import { UserProfileStateProcessor } from "./processor/user-profile-state-processor";
import { DrivingBehaviorStateProcessor } from "./processor/driving-behavior-state-processor";
import { ITToolUsageStateProcessor } from "./processor/it-tool-usage-state-processor";
import { SafetyStateProcessor } from "./processor/safety-state-processor";
import { EconomyStateProcessor } from "./processor/economy-state-processor";
import { KpiOthersStateProcessor } from "./processor/kpi-others-state-processor";
import { CoachingStateProcessor } from "./processor/coaching-state-processor";
import { AchievementStateProcessor } from "./processor/achievement-state-processor";
import { TeamMessageStateProcessor } from "./processor/team-message-state-processor";

export interface IStateProcessor {
  GetDefaultSearchCriteria: () => CommonSearchCriteria[];

  SetSearchCriteria: (ctx: StateContext<AppDataStateModel>, searchCriteria: CommonSearchCriteria[]) => void;

  AttachSearchCriteriaIntoCurrent: (ctx: StateContext<AppDataStateModel>, newSearchCriteria: CommonSearchCriteria[]) => void;
}

class DefaultStateProcessor implements IStateProcessor {
  GetDefaultSearchCriteria() {
    return [] as CommonSearchCriteria[];
  }

  SetSearchCriteria(ctx: StateContext<AppDataStateModel>, searchCriteria: CommonSearchCriteria[]) { }

  AttachSearchCriteriaIntoCurrent(ctx: StateContext<AppDataStateModel>, newSearchCriteria: CommonSearchCriteria[]) { }
}

export class StateProcessorFactory {
  static processMapping: Map<string, IStateProcessor> = new Map<string, IStateProcessor>([
    [NgxsActionName.GET_DRIVER_DATA, new DriverDataStateProcessor()],
    [NgxsActionName.GET_ORG_UNIT, new OrgUnitStateProcessor()],
    [NgxsActionName.GET_USER_PROFILE, new UserProfileStateProcessor()],
    [NgxsActionName.GET_KPI_DRIVING_BEHAVIOR, new DrivingBehaviorStateProcessor()],
    [NgxsActionName.GET_KPI_IT_TOOL_USAGE, new ITToolUsageStateProcessor()],
    [NgxsActionName.GET_KPI_SAFETY, new SafetyStateProcessor()],
    [NgxsActionName.GET_KPI_ECONOMY, new EconomyStateProcessor()],
    [NgxsActionName.GET_KPI_OTHERS, new KpiOthersStateProcessor()],
    [NgxsActionName.GET_COACHING, new CoachingStateProcessor()],
    [NgxsActionName.GET_ACHIEVEMENT, new AchievementStateProcessor()],
    [NgxsActionName.GET_AWARD, new AwardStateProcessor()],
    [NgxsActionName.GET_TEAM_MESSAGE, new TeamMessageStateProcessor()]
  ]);

  static GetProcessor(functionName: string) {
    if (!StateProcessorFactory.processMapping.has(functionName)) {
      return new DefaultStateProcessor();
    }

    return StateProcessorFactory.processMapping.get(functionName);
  }
}
